<!-- E:\workspace_yongli\as_client\src\pages\system\position_level_list.vue -->
<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <m-search-item label="职级名称">
                    <c-input name="level_name"></c-input>
                </m-search-item>
            </m-search>

            <m-operate>
                <c-button color="main" v-if="auth('b_position_edit')" prepend-icon="tf-add" @click="add">创建职级</c-button>
            </m-operate>

            <c-table ref="list" height="grow">
                <c-table-column
                        label="职级名称"
                        name="level_name"
                        width="150"
                >
                </c-table-column>

                <c-table-column
                        label="职级排序"
                        name="sort"
                        width="100"
                >
                </c-table-column>

                <c-table-column
                        label="创建人"
                        name="creater_name"
                        width="100"
                >
                </c-table-column>

                <c-table-column
                        label="创建时间"
                        name="create_date"
                        width="140"
                ></c-table-column>

                <c-table-column
                        type="button"
                        label="操作"
                        width="110"
                >
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_position_edit')" icon="tf-edit" @click="edit(data)">编辑</c-table-button>
                        <c-table-button v-if="auth('b_position_edit')" icon="tf-trash" @click="remove(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>

            <!-- 编辑弹窗 -->
            <position-level-edit ref="positionLevelEdit" @resolve="$refs.list.update()"></position-level-edit>
        </module>
    </page>
</template>

<script>
import positionLevelEdit from "./position_level_edit.vue";

export default {
    components: {
        positionLevelEdit
    },

    mounted() {
        this.searchHandle();
    },

    methods: {
        /************搜索列表**************/
        searchHandle(data = {}) {
            this.$refs.list.load({
                url: '/position_level/list',
                data
            });
        },

        /************添加**************/
        add() {
            this.$refs.positionLevelEdit.open();
        },

        /************编辑**************/
        edit(data) {
            this.$refs.positionLevelEdit.open(data);
        },

        /************排序**************/
        sortHandle(row, type, next) {
            this.request({
                url: '/position_level/sort',
                data: {
                    id: row.data.id,
                    sort_type: type
                },
                loading: true,
                success: data => {
                    next();
                    this.$message({
                        message: '排序成功',
                        type: 'success'
                    });
                },
                error: (error) => {
                    console.error('排序失败:', error);
                    this.$message({
                        message: '排序失败，请重试',
                        type: 'error'
                    });
                }
            });
        },

        /************删除**************/
        remove(data) {
            this.$confirm({
                message: `确认删除岗位级别【${data.level_name}】？删除后不可恢复`,
                buttonName: '确定',
                cancelButton: true,
                resolve: () => {
                    this.request({
                        url: '/position_level/delete',
                        data: { id: data.id },
                        loading: true,
                        success: data => {
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });
                            this.$refs.list.update();
                        },
                        error: (error) => {
                            console.error('删除失败:', error);
                            this.$message({
                                message: error.message || '删除失败，请重试',
                                type: 'error'
                            });
                        }
                    });
                },
                cancel: () => {}
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>
